import Request from '@/api/request';

export const getProfile = async () => {
  let params = {}
  return await Request.get('/v1/users/me/profile', params).then((res) => {
    return res;
  });
};

export const putProfile = async (profileData) => {
  return await Request.put('/v1/users/me/profile', profileData).then((res) => {
    return res;
  });
};

export const postAvatar = async (fileAvatar) => {
  let uri = '/v1/users/me/avatar';
  return await Request.fileformpost(uri,'fileavatar', fileAvatar).then((res) => {
    return res;
  });
}

export const getMeOrders = async (params) => {
  const requestParams = {
    ...params,
    sort: {
      'id' : -1,
    },
    pagination: {
      'start' : 0,
      'limit' : 100,
    }
  };
  return await Request.get('/v1/users/me/orders', requestParams).then((res) => {
      return res;
  });
}

export const getOrderBadges = async (orderid) => {
  return await Request.get('/v1/users/me/orders/' + orderid + '/badges', {}).then((res) => {
    return res;
  });
}

export const getMeBadges = async () => {
  return await Request.get('/v1/users/me/badges', {}).then((res) => {
    return res;
  });
}

export const getMeCreateBadges = async (params) => {
  return await Request.get('/v1/users/me/created-badges', params).then((res) => {
    return res;
  });
}

export const putOrderCancel = async (orderid) => {
  return await Request.put('/v1/orders/'+orderid+'/cancel', {}).then((res) => {
    return res;
  });
}

export const postOrderRefunds = async (orderid, params = {}) => {
  const requestParams = {
    ...params,
    orderid:orderid
  };
  return await Request.formpost('/v1/payment/refunds', requestParams).then((res) => {
    return res;
  });
};  

export const getMerchant = async (id) => {
  let params = {};
  return await Request.get('/v1/merchants/' + id, params).then((res) => {
    return res;
  });
}

export const biztaxers = async (params) => { 
  return await Request.get('/v1/utils/biztaxers', params).then((res) => {
    return res;
  });
};

export const postBiztaxers = async (params) => { 
  params.start = 0;
  params.num   = 20;
  return await Request.post('/v1/utils/biztaxers', params).then((res) => {
    return res;
  });
};

export const getInvoices = async (orderid, params = {}) => {
  return await Request.get('/v1/orders/' +orderid+ '/invoices', params).then((res) => {
    return res;
  });
};  

export const postInvoice = async (orderid, params = {}) => {
  return await Request.formpost('/v1/orders/' +orderid+ '/invoices', params).then((res) => {
    return res;
  });
};

export const getMeManuscripts = async (start, limit) => {
  let params = {};
  const requestParams = {
    ...params,
    sort: {
      'id' : -1,
    },
    pagination: {
      'start' : start,
      'limit' : limit,
    }
  };
  return await Request.get('/v1/users/me/manuscripts', requestParams).then((res) => {
    return res;
  });
}

export const getMeManuscriptFile = async (id, params) => {
  return await Request.get('/v1/users/me/manuscripts/' + id + '/files', params).then((res) => {
    return res;
  });
} 

export const postMeManuscriptFile = async (id, file, params) => {
  return await Request.fileformpost('/v1/users/me/manuscripts/' + id + '/files', 'file', file, params).then((res) => {
    return res;
  });
}

export const offlineMeManuscriptFile = async (id  , fileid) => {
  return await Request.delete('/v1/users/me/manuscripts/' + id + '/files/' + fileid).then((res) => {
    return res;
  });
}

export const postOrderPaidproof = async (orderid, chargeid, fileProof, params) => {
  return await Request.fileformpost('/v1/users/me/orders/' +orderid + '/charges/' + chargeid + '/proof', 'fileproof', fileProof, params).then((res) => {
    return res;
  });
}